module.exports = __webpack_public_path__ + "static/1241736799.ab1b7fb6.jpg";